(function () {
  "use strict";

  if (window.ScummyDripCryptAccess) {
    window.ScummyDripCryptAccess.initialize();
    return;
  }

  var STORAGE_PREFIX = "scummy-drip-crypt:";

  function DripCryptAccess(element) {
    this.element = element;
    this.form = element.querySelector("[data-drip-crypt-form]");
    this.input = element.querySelector("[data-drip-crypt-input]");
    this.submit = element.querySelector("[data-drip-crypt-submit]");
    this.toggle = element.querySelector("[data-drip-crypt-toggle]");
    this.status = element.querySelector("[data-drip-crypt-status]");
    this.gate = element.querySelector("[data-drip-crypt-gate-panel]");
    this.content = element.querySelector("[data-drip-crypt-content]");
    this.products = element.querySelector("[data-drip-crypt-products-target]");
    this.lockedCopy = element.querySelector("[data-drip-crypt-locked-copy]");
    this.unlockedCopy = element.querySelector("[data-drip-crypt-unlocked-copy]");
    this.unlockedTitle = element.querySelector("[data-drip-crypt-unlocked-title]");
    this.stage = element.querySelector(".drip-crypt__stage");
    this.countdown = element.querySelector("[data-drip-crypt-countdown]");
    this.announcement = element.querySelector("[data-drip-crypt-unlock-announcement]");
    this.proxyPath = (element.getAttribute("data-proxy-path") || "/apps/drip-crypt").replace(/\/+$/, "");
    this.dropId = element.getAttribute("data-drop-id") || "current";
    this.storageKey = STORAGE_PREFIX + this.dropId;
    this.messages = {
      required: element.getAttribute("data-message-required") || "ENTER YOUR PASSCODE TO CONTINUE.",
      incorrect: element.getAttribute("data-message-incorrect") || "THAT PASSCODE ISN’T CORRECT. CHECK IT AND TRY AGAIN.",
      limited: element.getAttribute("data-message-limited") || "TOO MANY ATTEMPTS. WAIT A FEW MINUTES AND TRY AGAIN.",
      closed: element.getAttribute("data-message-closed") || "EARLY ACCESS IS NOT OPEN YET.",
      unavailable: element.getAttribute("data-message-unavailable") || "THE CRYPT CAN’T BE REACHED RIGHT NOW. TRY AGAIN IN A MOMENT.",
      show: element.getAttribute("data-label-show") || "Show passcode",
      hide: element.getAttribute("data-label-hide") || "Hide passcode",
      unlock: element.getAttribute("data-label-unlock") || "UNLOCK",
      checking: element.getAttribute("data-label-checking") || "CHECKING…"
    };
    this.busy = false;
    this.boundOnProductsClick = this.onProductsClick.bind(this);
  }

  DripCryptAccess.prototype.start = function () {
    if (!this.form || !this.input || !this.submit || !this.status || !this.gate || !this.content || !this.products) {
      return;
    }

    this.form.addEventListener("submit", this.onSubmit.bind(this));
    if (this.toggle) this.toggle.addEventListener("click", this.onToggle.bind(this));
    this.input.addEventListener("input", this.onInput.bind(this));

    var token = this.readToken();
    if (token) this.loadContent(token, true);
  };

  DripCryptAccess.prototype.startQuickView = function () {
    this.element.addEventListener("click", this.boundOnProductsClick);
  };

  DripCryptAccess.prototype.onSubmit = function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.busy) return;

    var passcode = this.input.value.trim();
    if (!passcode) {
      this.showStatus(this.messages.required);
      this.input.focus();
      return;
    }

    this.setBusy(true);
    this.showStatus("");

    this.post("/unlock", { passcode: passcode })
      .then(function (response) {
        return response.json().catch(function () {
          return {};
        }).then(function (body) {
          return { response: response, body: body };
        });
      })
      .then(function (result) {
        if (!result.response.ok || !result.body.token) {
          if (result.response.status === 401) throw new Error("invalid_passcode");
          if (result.response.status === 429) throw new Error("rate_limited");
          if (result.response.status === 423) throw new Error("closed");
          throw new Error("unavailable");
        }

        this.saveToken(result.body.token);
        return this.loadContent(result.body.token, false);
      }.bind(this))
      .catch(function (error) {
        this.setBusy(false);

        if (error.message === "invalid_passcode") {
          this.showStatus(this.messages.incorrect);
          this.showPasscodeError();
          this.input.focus();
          this.input.select();
          return;
        }

        if (error.message === "rate_limited") {
          this.showStatus(this.messages.limited);
          return;
        }

        if (error.message === "closed") {
          this.showStatus(this.messages.closed);
          return;
        }

        this.showStatus(this.messages.unavailable);
      }.bind(this));
  };

  DripCryptAccess.prototype.loadContent = function (token, restoring) {
    if (restoring) this.setBusy(true);

    return this.post("/content", { token: token })
      .then(function (response) {
        if (!response.ok) {
          if (response.status === 401) throw new Error("invalid_token");
          throw new Error("unavailable");
        }
        return response.text();
      })
      .then(function (html) {
        this.products.innerHTML = html;
        this.revealContent(restoring);
      }.bind(this))
      .catch(function (error) {
        this.clearToken();
        this.setBusy(false);
        this.gate.hidden = false;

        if (!restoring) throw error;
        if (error.message === "invalid_token") {
          this.showStatus("");
          return;
        }
        this.showStatus(this.messages.unavailable);
      }.bind(this));
  };

  DripCryptAccess.prototype.revealContent = function (restoring) {
    var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var delay = restoring || reducedMotion ? 0 : 220;

    this.showStatus("");
    if (delay) this.element.classList.add("is-unlocking");

    window.setTimeout(function () {
      this.content.hidden = false;
      this.gate.hidden = true;
      if (this.lockedCopy) this.lockedCopy.hidden = true;
      if (this.unlockedCopy) this.unlockedCopy.hidden = false;
      if (this.stage && this.unlockedTitle && this.unlockedTitle.id) {
        this.stage.setAttribute("aria-labelledby", this.unlockedTitle.id);
      }
      if (this.countdown) this.countdown.hidden = true;
      this.element.classList.remove("is-unlocking");
      this.element.classList.add("is-unlocked");
      this.excludeCurrentProducts();
      this.setBusy(false);
      if (!restoring && this.unlockedTitle && (document.activeElement === document.body || this.form.contains(document.activeElement))) {
        this.unlockedTitle.focus({ preventScroll: true });
      }
      if (this.announcement && this.unlockedCopy) {
        this.announcement.textContent = this.unlockedCopy.textContent.trim();
      }

      document.dispatchEvent(new CustomEvent("drip-crypt:unlocked", {
        detail: { dropId: this.dropId }
      }));
    }.bind(this), delay);
  };

  DripCryptAccess.prototype.excludeCurrentProducts = function () {
    var live = this.element.querySelector('.drip-crypt__live-products');
    if (!live) return;
    // Only inspect the authorized response after it has been received.
    var paths = new Set(Array.from(this.products.querySelectorAll('.product-item__image-link[href]'), function (link) {
      return new URL(link.href, window.location.origin).pathname;
    }));
    var remaining = 0;
    live.querySelectorAll('.drip-crypt-products__item').forEach(function (card) {
      var link = card.querySelector('.product-item__image-link[href]');
      card.hidden = Boolean(link && paths.has(new URL(link.href, window.location.origin).pathname));
      if (!card.hidden) remaining += 1;
    });
    if (paths.size && !remaining) live.hidden = true;
  };

  DripCryptAccess.prototype.onProductsClick = function (event) {
    var trigger = event.target.closest(".show-product-quickview");
    if (!trigger || !this.element.contains(trigger)) return;

    var productUrl = trigger.getAttribute("href");
    if (!productUrl) return;

    event.preventDefault();
    event.stopPropagation();
    document.dispatchEvent(new CustomEvent("drip-crypt:quick-view", {
      detail: { productUrl: productUrl }
    }));
  };

  DripCryptAccess.prototype.post = function (path, body) {
    var controller = typeof AbortController === "function" ? new AbortController() : null;
    var timeout = controller ? window.setTimeout(function () {
      controller.abort();
    }, 12000) : 0;
    var requestBody = Object.assign({ dropId: this.dropId }, body);

    return fetch(this.proxyPath + path, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "accept": "application/json, text/html",
        "content-type": "application/json"
      },
      body: JSON.stringify(requestBody),
      cache: "no-store",
      signal: controller ? controller.signal : undefined
    }).finally(function () {
      if (timeout) window.clearTimeout(timeout);
    });
  };

  DripCryptAccess.prototype.onToggle = function () {
    var showing = this.input.type === "text";
    this.input.type = showing ? "password" : "text";
    this.toggle.setAttribute("aria-pressed", String(!showing));
    this.toggle.setAttribute("aria-label", showing ? this.messages.show : this.messages.hide);
    this.input.focus();
  };

  DripCryptAccess.prototype.onInput = function () {
    if (this.status.textContent) this.showStatus("");
    this.element.classList.remove("has-passcode-error");
  };

  DripCryptAccess.prototype.setBusy = function (busy) {
    this.busy = busy;
    this.submit.disabled = busy;
    this.input.disabled = busy;
    var label = this.submit.querySelector("span");
    if (label) label.textContent = busy ? this.messages.checking : this.messages.unlock;
    this.element.setAttribute("aria-busy", String(busy));
  };

  DripCryptAccess.prototype.showStatus = function (message) {
    this.status.textContent = message;
  };

  DripCryptAccess.prototype.showPasscodeError = function () {
    this.element.classList.remove("has-passcode-error");
    this.element.classList.add("has-passcode-error");
  };

  DripCryptAccess.prototype.readToken = function () {
    try {
      return window.sessionStorage.getItem(this.storageKey);
    } catch {
      return null;
    }
  };

  DripCryptAccess.prototype.saveToken = function (token) {
    try {
      window.sessionStorage.setItem(this.storageKey, token);
    } catch {
      // The current page remains unlocked when session storage is unavailable.
    }
  };

  DripCryptAccess.prototype.clearToken = function () {
    try {
      window.sessionStorage.removeItem(this.storageKey);
    } catch {
      // No additional cleanup is required.
    }
  };

  function initialize() {
    document.querySelectorAll("[data-drip-crypt-access]").forEach(function (element) {
      if (element.getAttribute("data-drip-crypt-access-ready") === "true") return;
      element.setAttribute("data-drip-crypt-access-ready", "true");
      var controller = new DripCryptAccess(element);
      controller.startQuickView();
      if (element.getAttribute("data-mode") === "password") controller.start();
    });
  }

  window.ScummyDripCryptAccess = {
    Controller: DripCryptAccess,
    initialize: initialize
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    initialize();
  }

  document.addEventListener("shopify:section:load", initialize);
}());
